import ActionButton from 'components/ActionButton';
import React, { useState } from 'react';
import { updateOrderItemStatus } from 'services/api/orderItem';
import { ORDER_ITEM_STATUS, showError } from 'utils';

const MarkOrderItemPacked = (props) => {
  const { item, debouncedRefresh, setNewlyPackedItemIds, newlyPackedItemIds } = props;
  const [isPacked, setIsPacked] = useState(item.status === ORDER_ITEM_STATUS.PACKED || newlyPackedItemIds?.includes(item?.objectId));

  const updateOrderItemStatusFn = async (orderItemId: string) => {
    try {
      setIsPacked(true);
      setNewlyPackedItemIds([...newlyPackedItemIds, item?.objectId]);
      await updateOrderItemStatus({ orderItemId, status: ORDER_ITEM_STATUS.PACKED });
      await debouncedRefresh();
    } catch (e) {
      console.log(e);
      showError(e);
      setIsPacked(false);
    } finally {
    }
  };

  return(
    <div className={'d-flex'}>
      <ActionButton
        onClick={() => updateOrderItemStatusFn(item.objectId)}
        active={!isPacked}
        isLoading={false}
        text={'Mark Packed'}
        customClass={'mr-2'}
      />
    </div>
  );
};
export default MarkOrderItemPacked;